import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type PortsTabType = 'departing' | 'visiting';

export interface PortsGalleryTabsState {
  selectedTab: PortsTabType;
  tabIsSwitched: boolean;
}

const initialState: PortsGalleryTabsState = {
  selectedTab: 'departing',
  tabIsSwitched: false,
};

export const portsGalleryTabsSlice = createSlice({
  name: 'portsGalleryTabs',
  initialState,
  reducers: {
    setSelectedTab: (state, action: PayloadAction<PortsTabType>) => {
      state.selectedTab = action.payload;
    },
    setTabIsSwiched: (state, action: PayloadAction<boolean>) => {
      state.tabIsSwitched = action.payload;
    },
  },
});

export const { setSelectedTab, setTabIsSwiched } = portsGalleryTabsSlice.actions;
export default portsGalleryTabsSlice.reducer;
